import type { User } from '@pray/shared/types/user';
import logger from '@pray/shared/utils/logger';

import * as hubspot from './hubspot';

/**
 * Analytics user identification utility for Studio app
 * Handles user identification across multiple analytics services when user signs in/signs up
 */

export const identifyUser = (user: User) => {
  if (!user || !user.is_registered) {
    logger.info('Analytics user identification: No user or user is not registered');
    return;
  }

  try {
    // Track user identification event
    hubspot.identifyUser({ email: user.email });

    logger.debug('Analytics user identification completed successfully', {
      email: user.email,
      isRegistered: user.is_registered,
    });
  } catch (error) {
    logger.error('Analytics user identification failed', error, {
      email: user.email,
      isRegistered: user.is_registered,
    });
  }
};

export default {
  identifyUser,
};
